module.exports = __webpack_public_path__ + "img/floor_EG2.972eec19.svg";